var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"visualizationContainer",class:[
    'visualizations-container',
    { hide: _vm.hide },
    ("visualizations-container__" + _vm.size) ]},[_c('div',[_c('Heatmap',{attrs:{"currentTime":_vm.currentTime,"heatmapBucket":_vm.heatmapBucket,"activeCommentVerbatimId":_vm.activeCommentVerbatimId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }